import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, Link, useLocation } from "react-router-dom";
import $ from 'jquery';
import Modal from "react-modal";
import { withRouter } from '../utils/withRouter';


const VisitorTopMenu = ({ head, userId }) => {
    const history = useNavigate();
    const navigate = useNavigate();
    const location = useLocation();

    const [isOpen, setIsOpen] = useState(false)
    const [loginAccesslist, setLoginAccesslist] = useState([])

    //toggle model for logout.................................
    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const loadScripts = () => {
        // This array contains all the files/CDNs 
        // const dynamicScripts = [
        //     'js/jquery.sticky.js',
        //     'js/metisMenu.min.js',
        //     'js/metisMenu-active.js',
        //     'js/main.js'
        // ];

        // for (let i = 0; i < dynamicScripts.length; i++) {
        //     const node = document.createElement('script');
        //     node.src = dynamicScripts[i];
        //     node.type = 'text/javascript';
        //     node.async = false;
        //     document.getElementsByTagName('head')[0].appendChild(node);
        // }
    }
    const logout = () => {
        sessionStorage.clear()
        navigate('/')
    }
    useEffect(() => {
        !sessionStorage.getItem("visitorTabName") && sessionStorage.setItem("visitorTabName", "/visitordashboard")
        // loadScripts();
        // console.log("233", JSON.parse(sessionStorage.getItem('LoginAccesslist'))[0]['IsRead'])
        // setLoginAccesslist(JSON.parse(sessionStorage.getItem('LoginAccesslist')))
    }, []);

    const onRedirect = (path) => {
        history.push({ pathname: path, state: { 'isSearchClear': true } });
    }

    const isRouteActive = (routePath) => {
        const isPath = location.pathname == routePath
        if (isPath) {
            sessionStorage.removeItem("visitorTabName")
        }
        return isPath ? location.pathname == routePath : sessionStorage.getItem("visitorTabName") == routePath
    }

    return (
        <>
            <Modal isOpen={isOpen} onRequestClose={e => toggleModal()}>
                <div className="modal-dialog modal-dialog-centered bd-example-modal-lg" >
                    <div className="modal-content" style={{ borderRadius: '0px' }}>
                        <div className="modal-header p-2">
                            <h4 className="modal-title">Confirm Logout</h4>
                            {/* <button type="button" class="close modal-close" data-dismiss="modal" onClick={this.toggleModal}>&times;</button> */}
                            <button style={{ backgroundColor: '#eee' }} type="button " className="close pop-close text-dark" data-dismiss="modal" onClick={e => toggleModal()} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>

                        </div>
                        <div class="modal-body pl-0 pt-4 pb-4">
                            <p class="pop_label">Do you really want to logout?</p>
                        </div>
                        <div className='modal-footer d-block p-2'>
                            <button className="btn btn-outline-danger" onClick={logout}> Yes</button>
                            <button class="btn btn-gray" data-dismiss="modal" onClick={toggleModal}> No</button>
                        </div>

                    </div>
                </div>
            </Modal>
            {/* Top menu */}
            <div className="navg-1 pb-1" style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
                <ul className="nav nav-pills d-flex flex-nowrap" style={{ whiteSpace: 'nowrap', border: 'none' }}>
                    <li className="nav-item flex-shrink-0" onClick={() => sessionStorage.setItem("visitorTabName", "/visitordashboard")}>
                        <Link to={'/visitordashboard'} className={isRouteActive('/visitordashboard') ? "nav-link active px-4 py-2" : "nav-link px-4 py-2"}>
                            Dashboard
                        </Link>
                    </li>
                    <li className="nav-item flex-shrink-0" onClick={() => sessionStorage.setItem("visitorTabName", "/visitorForm")}>
                        <Link to={'/visitorForm'} className={isRouteActive('/visitorForm') ? "nav-link active px-4 py-2" : "nav-link px-4 py-2"}>
                            Profile
                        </Link>
                    </li>
                    <li className="nav-item flex-shrink-0">
                        <Link to={'/recommendation'} className={isRouteActive('/recommendation') || isRouteActive('/recommendationViewDetails') || isRouteActive('/recommendationBookNow') ? "nav-link active px-4 py-2" : "nav-link px-4 py-2"}>
                            AI Recommendate Matching/All Exhibitors
                        </Link>
                    </li>
                    <li className="nav-item flex-shrink-0">
                        <Link to={'/mySchedule'} className={isRouteActive('/mySchedule') ? "nav-link active px-4 py-2" : "nav-link px-4 py-2"}>
                            My Event Activity
                        </Link>
                    </li>
                </ul>
                {/* <span className="log-1" onClick={e => toggleModal()}>
                    <i className="fa fa-power-off" aria-hidden="true" /> Logout
                </span> */}
            </div>

            {/* Top menu */}

        </>
    );
}
export default VisitorTopMenu;